import $http from "@/helpers/api";
import { objectToFormData } from "@/helpers/formdata";

// initial state
const state = {
  all: [],
  repair: {},
  repair_asf: [],
  status: [],
  parts: [],
  client_repairs: []
};

// getters
const getters = {
  get: state => state.repair,
  getAll: state => state.all,
  getAsf: state => state.repair_asf,
  getStatus: state => state.status,
  getParts: state => state.parts,
  getUserdParts: state => state.usedparts, //marcel 2020-03-22: mostrar used parts no repair
  inWarranty: state => {
    let warr = ["In Warranty", "Partial Warranty"];
    return warr.includes(state.repair.warranty);
  }
};

// actions
const actions = {
  getAll({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      $http
        .get("/repairs", {
          params: {
            includes: ["status", "issues", "asf"],
            filter_groups: [
              {
                filters: [
                  {
                    key: "asf",
                    value: rootGetters["auth/getCurrentAsf"],
                    operator: "eq"
                  }
                ]
              }
            ]
          }
        })
        .then(resp => {
          let arr = [];
          resp.data.repairs.forEach(function(item, i) {
            arr[i] = {
              "#": item.repair_id,
              id: item.id,
              asf: item.asf ? item.asf.name : "",
              product: item.model_name,
              status: item.status[item.status.length - 1]
                ? item.status[item.status.length - 1].status_name
                : ""
            };
          });
          commit("setAll", arr);
        });
      resolve();
    });
  },
  get({ commit }, repairId) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          "/repairs/" +
            repairId +
            "?includes[]=status&includes[]=asf&includes[]=accessories&includes[]=customer&includes[]=issues&includes[]=customer_issues&includes[]=repair_parts&includes[]=repair_used_parts&includes[]=uploads"
        )
        .then(resp => {
          commit("set", resp.data.repair);
          commit("setAsf", resp.data.repair.asf);
          commit("cart/setCart", resp.data.repair.repair_parts, { root: true });
          commit("cart/setCartUsedParts", resp.data.repair.repair_used_parts, { root: true });//marcel 2020-03-20
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  add(context, data) {
    let form_data = objectToFormData(data);
    return new Promise((resolve, reject) => {
      $http
        .post("/repairs", form_data, {
          headers: { "content-type": "multipart/form-data" }
        })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  edit({ commit }, data) {
    //marcel 2020-03-31: trocando de put para post por causa do envio de arquivos
    let form_data = objectToFormData(data);
    return new Promise((resolve, reject) => {
      $http
        .post("/repairs/" + data.id, form_data, {
          headers: {
              "content-type": "multipart/form-data"
          }        
        })
        .then(resp => {
          commit("clear");
          resolve(resp);
        })
        .catch(error => {
          return console.log(error);
          reject(error);
        });
    });
  },
  getByClient(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/repairs/client", data, {
          headers: {
              "content-type": "application/json"
          }        
        })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          return console.log(error);
          reject(error);
        });
    });
  },
  search(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .get("/repairs", { params: data })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delete({}, data) {
    return new Promise((resolve, reject) => {
      $http
        .delete("/repairs/" + data)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getStatus({ commit }, repair_id) {
    return new Promise((resolve, reject) => {
      $http
        .get("/status/" + repair_id)
        .then(resp => {
          commit("setStatus", resp.data);
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateStatus({ commit }, status) {
    return new Promise((resolve, reject) => {
      $http
        .post("/status", { status: status })
        .then(resp => {
          commit("set", resp.data);
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  batchChangeStatus({ commit }, status, repairs) {
    return new Promise((resolve, reject) => {
      $http
        .post("/batch/status", { status: status, repairs: repairs })
        .then(resp => {
          commit("set", resp.data);
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  setStatus(state, status) {
    state.status = status;
  },
  setParts(state, parts) {
    state.parts = parts;
  },
  setAll(state, repairs) {
    state.all = repairs;
  },
  set(state, repair) {
    state.repair = repair;
    state.repair.customer_issues_2 = repair.customer_issues;
  },
  setAsf(state, asf) {
    state.repair_asf = asf;
  },
  clear(state) {
    state.repair = [];
  },
  clearAll(state) {
    state.all = [];
    state.repair = [];
    state.status = [];
    state.parts = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
